import React from 'react';
import { useEffect, useState } from 'react';
import './ChickenPage.css';
import Button from './Button';
import Box from './Box';
import AnimeChicken from './AnimeChicken.js';
import { useParams, Link } from "react-router-dom";


function ChickenList(props) {
  //const [metadata, setMetadata] = useState(null);
  const API = props.api;
  const walletAddress = useParams().walletAddress
  // trigger on component mount
  useEffect(() => {
    //API.setQueryTokenId(tokenId);
    API.fetchAllChickenBy(walletAddress)
  }, [API.currentAccount]);

  const listItems = API.allChicken.map((i) =>
    <div className="pure-u-1 pure-u-md-1-3 pure-u-lg-1-4 pure-u-xl-1-5" key={i.toString()} >
      <div style={{ margin: '10px' }}>
        <Link to={`/${i}`}>
          <Button>
            <div>
              <img src={`/images/${i}.png`} style={{ height: '100px' }} /> <br /> {`Chicken #${i}`}
            </div>
          </Button>
        </Link>
      </div>
    </div>
  );

  return (
    <div>

      <AnimeChicken tokenId={''} >
        <div style={{
          position: 'fixed',
          width: '100%',
          height: '100%',
          overflow: 'scroll',
          zIndex: 999
        }}>
          <h1>wallet </h1>
          {/*<p style={{margin: '-10px 0 20px 0'}} >{API.currentAccount}</p>*/}
          <div className="pure-g">
            {listItems}
            {listItems.length == 0 &&

              <div class="pure-u-1"><Link to={`/`}>
                <Button> {"No Chicken, back to home to mint? "}
                  <img src='/img/home-icon.svg' style={{ height: '20px' }}></img>
                </Button>
              </Link></div>}
          </div>
        </div>
      </AnimeChicken>

    </div>
  )
}

export default ChickenList;
